"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var ThumbsUp = function ThumbsUp(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2["default"])({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    d: "M5.752 11.382h1.26c.388 0 .754-.18.99-.488l2.492-3.238a1.25 1.25 0 00.26-.762V4.507a.616.616 0 01.625-.625c.802 0 1.875.937 1.875 2.812a8.356 8.356 0 01-.514 3.212.158.158 0 00.14.225h4.074a1.285 1.285 0 011.287 1.06c.08.521-.178 1.036-.642 1.284a1.241 1.241 0 01-.179 2.268c.228.16.394.393.471.66.081.303.045.624-.1.901a1.125 1.125 0 01-.97.684c.135.217.198.471.181.726a1.302 1.302 0 01-1.321 1.168h-4.664a5.002 5.002 0 01-2.774-.84l-.3-.2a1.25 1.25 0 00-.694-.21H5.752a.625.625 0 01-.625-.625v-5a.625.625 0 01.625-.625z",
    fill: "currentColor"
  }));
};

var _default = (0, _react.forwardRef)(ThumbsUp);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ThumbsUp, "ThumbsUp", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/ThumbsUp.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/ThumbsUp.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();